import { render } from "./GanttGridGroup.vue?vue&type=template&id=601724d0"
import script from "./GanttGridGroup.vue?vue&type=script&lang=ts"
export * from "./GanttGridGroup.vue?vue&type=script&lang=ts"
script.render = render

export default script